import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";
import type { GroupResponse } from "@/script/req";
import { useQuery } from "@tanstack/react-query";
import { useIsAdmin } from "./useAuth";

/** 관리자 전용: GET /groups */
export function useAdminGroupsQuery() {
  const isAdmin = useIsAdmin();
  return useQuery({
    queryKey: QUERY_KEYS.groups.list(),
    queryFn: async () => {
      const res = await httpClient.get<GroupResponse[]>("/groups");
      return res ?? [];
    },
    enabled: isAdmin,
    staleTime: 5 * 60 * 1000,
  });
}
